<template>
  <div class="splash">
    <div class="img_splash_logo"><img src="/assets/img/common/logo.png" alt=""></div>
  </div>
</template>

<script>
export default {
  name: 'Splash',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
